/* 
 * Algodex Frontend (algodex-react) 
 * Copyright (C) 2021 - 2022 Algodex VASP (BVI) Corp.
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published
 * by the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.

 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <https://www.gnu.org/licenses/>.
 */

// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from '@sentry/nextjs'

const SENTRY_DSN = process.env.SENTRY_DSN || process.env.NEXT_PUBLIC_SENTRY_DSN

// Sentry events should never be captured/sent in local development.
// This marks them as such, just in case.

const getSentryEnv = () => {
  if (process.env.NEXT_PUBLIC_SENTRY_ENV) {
    return process.env.NEXT_PUBLIC_SENTRY_ENV
  }

  return process.env.NEXT_PUBLIC_ENV || 'development'
}
const ENVIRONMENT = getSentryEnv()

Sentry.init({
  dsn: SENTRY_DSN || 'https://1573deb1875c4a53a47ee128a24c042f@o861560.ingest.sentry.io/5841341',
  environment: ENVIRONMENT,
  enabled: ENVIRONMENT !== 'development',
  // Adjust this value in production, or use tracesSampler for greater control
  tracesSampleRate: 1.0
  // ...
  // Note: if you want to override the automatic release value, do not set a
  // `release` value here - use the environment variable `SENTRY_RELEASE`, so
  // that it will also get attached to your source maps
})
